import type { LumoraClient } from "@lumora/bridge";
import { errorMessage } from "@lumora/bridge";
import { useState } from "react";

export interface PayoutsPanelProps {
  busy: boolean;
  error: string | null;
  onStart: () => void;
}

/** Presentational Stripe Connect entry for owners (partner sites get paid out through it). */
export function PayoutsPanel({ busy, error, onStart }: PayoutsPanelProps) {
  return (
    <section className="portal-section" data-lumora-view="payouts">
      <h2>Payouts</h2>
      <p className="muted">Connect your bank account with Stripe to receive payouts from your site.</p>
      {error ? (
        <p className="portal-error" data-lumora-error>
          {error}
        </p>
      ) : null}
      <button type="button" disabled={busy} onClick={onStart}>
        {busy ? "Opening Stripe…" : "Set up payouts"}
      </button>
    </section>
  );
}

export interface PayoutsSectionProps {
  siteSlug: string;
  client: Pick<LumoraClient, "startOwnerConnectOnboarding">;
}

export function PayoutsSection({ siteSlug, client }: PayoutsSectionProps) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  return (
    <PayoutsPanel
      busy={busy}
      error={error}
      onStart={() => {
        setBusy(true);
        setError(null);
        const here = `${window.location.origin}${window.location.pathname}#/dashboard`;
        client.startOwnerConnectOnboarding(siteSlug, here, here).then(
          (r) => window.location.assign(r.url),
          (e: unknown) => {
            setBusy(false);
            setError(errorMessage(e, "Could not start payout setup."));
          },
        );
      }}
    />
  );
}

/** Owner/manager roles may mint their own Connect link (server enforces). */
export function canSetUpPayouts(role: string | null | undefined): boolean {
  return role === "owner" || role === "manager";
}
